import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66b13042"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "empty-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewLookUpValue = _resolveComponent("NewLookUpValue")!
  const _component_LookUpValue = _resolveComponent("LookUpValue")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_AsBlock = _resolveComponent("AsBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NewLookUpValue),
    (_ctx.lookUpGroups && _ctx.lookUpGroups.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lookUpGroups, (group) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group.type,
              class: "mb-4"
            }, [
              (group.lookUpValues && group.lookUpValues.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_AsBlock, {
                      header: group.type
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createVNode(_component_draggable, _mergeProps({
                          list: group.lookUpValues,
                          "item-key": "id",
                          onStart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drag = true)),
                          onEnd: ($event: any) => ((_ctx.drag = false), _ctx.refreshSortOrder(group.lookUpValues))
                        }, _ctx.dragOptions, {
                          handle: ".handle",
                          group: group.type
                        }), {
                          item: _withCtx(({ element }) => [
                            _createVNode(_component_LookUpValue, {
                              class: _normalizeClass(element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'),
                              lookUpValue: element
                            }, null, 8, ["class", "lookUpValue"])
                          ]),
                          _: 2
                        }, 1040, ["list", "onEnd", "group"])
                      ]),
                      _: 2
                    }, 1032, ["header"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_AsBlock, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('noData')), 1)
            ]),
            _: 1
          })
        ]))
  ], 64))
}